import { Customer } from "~/types";
export const getCallTypeIcon = function (callType: string): string {
  let url = "/svgs/";
  if (callType === "incoming") url += "inbound_call.svg";
  else url += "outbound_call.svg";
  return url;
};
export const getCleanedCustomerNumber = function (customerNumber: string) {
  let number = customerNumber;

  if (number.startsWith("+88")) {
    number = number.substring(3);
  } else if (number.startsWith("88")) {
    number = number.substring(2);
  } else if (number.startsWith("+")) {
    number = number.substring(1);
  }

  // Remove trailing "wss" if present
  if (number.slice(-3) === "wss") {
    number = number.split("-")[0];
  }

  return number;
};

interface CustomerUriInfo {
  phoneNumber: string;
  callHistoryId: number;
  queueName: string | null;
}

export const getCustomerUriInfo = (callerUri: string): CustomerUriInfo => {
  const parts = callerUri.split(";");
  const info: CustomerUriInfo = {
    phoneNumber: parts[0],
    callHistoryId: parseInt(parts[1]),
    queueName: null,
  };
  for (const p of parts.slice(2)) {
    const [k, v] = p.split("=");
    if (k === "q") info.queueName = v;
  }

  return info;
};

export const getCustomerBasicInfo = (customer: Customer) => {
  let info = "";
  info += customer.full_name;
  if (customer.gender) info += ` (${customer.gender})`;

  if (info == "undefined") return "Unknown Number";
  return info;
};

export const formatDuration = (s: number): string =>
  new Date(s * 1000).toISOString().slice(14, 19);
